/* eslint-disable import/export */
import { pipeable } from 'fp-ts';
import { constVoid } from 'fp-ts/function';
export * from 'fp-ts/Functor';
export const asUnit = (F) => (a) => F.map(a, constVoid);
export function lift(F) {
    return (f) => pipeable.map(F)(f);
}
export const letS = (F) => {
    const mapF = pipeable.map(F);
    return (f) => mapF((a) => ({ ...a, ...f(a) }));
};
//# sourceMappingURL=functor.js.map